import {classNames} from "@utils/class-names";
import React from "react";
import {ReactComponent as BoldIcon} from "@assets/icons/bold.svg";

interface BoldButtonProps {
    isActive: boolean;
    onFormat: (command: string) => void;
}

const BoldButton = (props: BoldButtonProps) => {
    const {isActive, onFormat} = props;

    return (
        <button
            type="button"
            onClick={() => onFormat("bold")}
            className={classNames(
                "px-2 w-10 h-10 hover:bg-on-surface/5 rounded-full flex items-center justify-center",
                isActive && "bg-primary/10 text-primary"
            )}
            title="Pogrubienie"
        >
            <BoldIcon className={isActive ? "text-primary" : ""}/>
        </button>
    )
}

export default BoldButton

